import React from 'react';
import { useWeb3 } from '../context/Web3Context';
import '../styles/loader.css';

export default function NetworkGuard() {
  const { networkOk, account, checkAndSwitchNetwork } = useWeb3();

  if (!account || networkOk) return null;

  return (
    <div className="network-overlay">
      <div className="network-modal">
        <div className="network-icon">&#9888;</div>
        <h3>Wrong Network</h3>
        <p>Please switch to the correct network to continue.</p>
        <button className="btn-gradient" onClick={checkAndSwitchNetwork}>
          Switch Network
        </button>
      </div>
    </div>
  );
}
